// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3N9XV","header":"ReportDetails_header__3kGwP","title":"ReportDetails_title__3ZUTn","left":"ReportDetails_left__2Frbb"};